<template>
  <div>
    <!--SMS AUTHENTICATION MODAL-->
    <smsAuthModal v-show="initialRequestLoaded" :optInCode="optInCode" :eMail="emailFromRegistration" :smsConfirmable="checkIfSmsIsConfirmableAfterInitialRequest"/>

    <!--REGISTRATION FORM-->
    <form>
        <profileDataAddChildComponent/>
        <gewinneModal/>

        <b-row class="justify-content-center">
            <!--<b-col sm="12" md="12">-->


            <b-col sm="12" md="10" class="section mb-3 p-3 clearfix">
                <h1 class="text-center mb-15">Registrierung abschließen</h1>
                <h5 class="text-center">Bitte fülle deine Daten aus, um deine Registrierung im McDonald’s Junior Club
                    abzuschließen.</h5>
            </b-col>
            <b-col sm="8" lg="5">
                <p class="mandatory-note text-center mt-50">* Pflichtfelder bitte ausfüllen</p>


                <div class="form-row">
                    <div class="col-12">
                        <h5 class="mb-0">Deine Anschrift</h5>
                    </div>
                    <div class="form-group floating-label col-9 float-left">
                        <span v-if="valid('street')" class="invalid-feedback">Bitte Straße eingeben!</span>
                        <input type="text"
                               class="form-control"
                               name="street"
                               :disabled="prefillData"
                               placeholder="Straße"
                               v-validate="'required'"
                               v-model="address.street">
                        <label>Straße*</label>
                    </div>
                    <div class="form-group floating-label col-3 float-right">
                        <span v-if="valid('housenumber')" class="invalid-feedback">Bitte Hausnummer eingeben!</span>
                        <input type="text"
                               v-validate="'required'"
                               class="form-control"
                               name="housenumber"
                               :disabled="prefillData"
                               placeholder="Hausnummer"
                               v-model="address.housenumber">
                        <label>Hausnummer*</label>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-4 floating-label">
                        <span v-if="valid('postcode')" class="invalid-feedback">Bitte PLZ eingeben!</span>
                        <input type="text"
                               class="form-control"
                               v-validate="'required|numeric'"
                               name="postcode"
                               :disabled="prefillData"
                               placeholder="PLZ"
                               v-model="address.postcode">
                        <label>PLZ*</label>
                    </div>
                    <div class="form-group col-8 floating-label">
                        <span v-if="valid('city')" class="invalid-feedback">Bitte Ort eingeben!</span>
                        <input type="text"
                               v-validate="'required'"
                               class="form-control"
                               :disabled="prefillData"
                               name="city"
                               placeholder="Ort"
                               v-model="address.city">
                        <label>Ort*</label>
                    </div>
                </div>

                <div class="form-row mb-60">
                    <div class="form-group col-9 mt-30">
                        <span v-if="errors.first('country')" class="invalid-feedback">Bitte Land auswählen!</span>
                        <b-form-select v-validate="'required'" name="country" v-model="address.country">
                            <option :value="null">Bitte Land auswählen</option>
                            <option value="DE">Deutschland</option>
                            <option value="LU">Luxemburg</option>
                        </b-form-select>
                    </div>
                </div>


                <div class="form-row mb-60">
                    <div class="col-12">
                        <h5 class="mb-0">Wähle ein Passwort</h5>
                    </div>
                    <div class="form-group floating-label col-12">
                        <input type="password" class="form-control" ref="pw1" name="password" v-validate="'required'" placeholder="Neues Passwort"
                               v-model="newPassword">
                        <label>Neues Passwort</label>
                        <i class="passwordIcon" :class="[isActive ? 'hide' : 'show']"
                           @click="showPassword($refs.pw1), isActive = !isActive"></i>
                    </div>
                    <div class="col-12 mt-15">
                        <p class="small mb-0">Bitte beachte: Das Passwort muss:</p>
                        <ul class="password-requirements">
                            <li :class="{active: eightChars}">- mindestens 8 Zeichen lang sein</li>
                            <li :class="{active: largeChar}">- mindestens einen Großbuchstaben enthalten</li>
                            <li :class="{active: smallChar}">- mindestens einen Kleinbuchstaben enthalten</li>
                            <li :class="{active: specialChar}">- mindestens ein Sonderzeichen enthalten</li>
                        </ul>
                    </div>
                </div>

                <div class="col-12">
                    <h5 class="mb-0">Welches ist dein McDonald's Lieblingsrestaurant?</h5>
                    <p class="small mb-0">Für dieses Restaurant erhältst du als Club-Mitglied regelmäßig Gutscheine.</p>
                </div>
                <profileChangeFavouriteRestaurantComponent
                        ref="typeAheadComponent"
                        v-model="favoriteRestaurant"
                        @favoriteRestaurantID="setFavRestaurant"
                        class="mb-3 fav-restaurant"/>

            </b-col>
        </b-row>

        <b-row class="justify-content-center mt-60 mb-60">
            <b-col sm="8" lg="5">

                <div class="form-row">
                    <div class="col-12">
                        <h5 class="mb-0">Melde dein(e) Kind(er) an, um tolle Geburtstagsüberraschungen zu bekommen</h5>
                    </div>
                </div>


                <div v-for="(child, index) in children" :key="index" class="child-data">
                    <div class="form-row mt-30">
                        <div class="col-6">
                            <p>{{index + 1}}. Kind</p>
                        </div>
                        <div class="col-6 text-right">
                            <a v-if="index > 0" @click="removeChild(index)" class="link">Kind entfernen</a>
                        </div>
                    </div>
<!--                    <div class="form-row">-->
<!--                        <div class="form-group col-12">-->
<!--                            <label class="standalone">Anrede*</label>-->
<!--                            <span v-if="errors.has('salutation' + index)"-->
<!--                                  class='invalid-feedback'>Bitte Anrede auswählen!</span>-->
<!--                            <b-form-radio :name="'salutation' + index"-->
<!--                                          v-validate="'required'" value="MR"-->
<!--                                          :disabled="prefillData && index == 0"-->
<!--                                          v-model="children[index].salutation">Junge</b-form-radio>-->
<!--                            <b-form-radio :name="'salutation' + index"-->
<!--                                          value="MRS"-->
<!--                                          :disabled="prefillData && index == 0"-->
<!--                                          v-model="children[index].salutation">Mädchen-->
<!--                            </b-form-radio>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="form-row">
                        <div class="form-group floating-label col-12">
                            <span v-if="valid('firstname' + index)" class='invalid-feedback'>Bitte Vornamen eingeben!</span>
                            <input v-validate="'required'"
                                   type="text"
                                   :name="'firstname' + index"
                                   :disabled="prefillData && index == 0"
                                   class="form-control"
                                   placeholder='Vorname'
                                   v-model.trim="children[index].firstname"/>
                            <label>Vorname des Kindes*</label>
                        </div>
                        <div class="form-group floating-label col-12">
                            <span v-if="valid('lastname' + index)" class='invalid-feedback'>Bitte Nachnamen eingeben!</span>
                            <input type="text"
                                   :name="'lastname' + index"
                                   :disabled="prefillData && index == 0"
                                   class="form-control"
                                   v-validate="'required'"
                                   placeholder='Nachname' v-model.trim="children[index].lastname">
                            <label>Nachname des Kindes*</label>
                        </div>
                    </div>
                    <div class="form-row mt-30">

                        <div class="form-group col-6 mb-0">
                            <label class="standalone">Geburtsmonat*</label>
                            <div v-if="errors.first('month')" class='invalid-feedback'>Bitte Monat auswählen!</div>
                            <b-form-select v-validate="'required'"
                                           name="month"
                                           class="mb-0"
                                           :disabled="prefillData && index == 0"
                                           v-model="children[index].birthMonth">
                                <option :value="null">Monat</option>
                                <option value="01">Januar</option>
                                <option value="02">Februar</option>
                                <option value="03">März</option>
                                <option value="04">April</option>
                                <option value="05">Mai</option>
                                <option value="06">Juni</option>
                                <option value="07">Juli</option>
                                <option value="08">August</option>
                                <option value="09">September</option>
                                <option value="10">Oktober</option>
                                <option value="11">November</option>
                                <option value="12">Dezember</option>
                            </b-form-select>
                        </div>

                        <div class="form-group col-6 mb-0">
                            <label class="standalone">Geburtsjahr*</label>
                            <div v-if="errors.first('year')" class='invalid-feedback'>Bitte Jahr auswählen!</div>
                            <b-form-select v-validate="'required'" name="year" class="mb-0"
                                           v-model="children[index].birthYear"
                                           :disabled="prefillData && index == 0"
                                           :options="birthYearOptions"/>
                        </div>
                        <div v-if="prefillData" class="form-group floating-label col-12">
                            <input type="text"
                                   class="form-control"
                                   :disabled="prefillData && index == 0"
                                   placeholder="Mitgliedsnr. Kind"
                                   v-model="children[index].membershipNumber">
                            <label>Mitgliedsnummer des Kindes</label>
                        </div>
                    </div>
                </div>

                <div v-if="prefillData" class="mt-30"><strong>Hinweis:</strong> Weitere Kinder, die bislang noch nicht im Junior Club angemeldet waren, kannst du erst später in deinem Log-In Bereich hinzufügen. Schließe bitte dafür zunächst deine Registrierung ab.</div>

                <a v-if="children.length < 5" class="btn btn-primary text-center mt-30" @click="addChild">+ Weiteres Kind
                    hinzufügen</a>
            </b-col>


        </b-row>
        <b-row class="justify-content-center">
            <b-col sm="8" lg="5">
                <h5 v-if="!prefillData" class="mb-0">Einwilligung zur Datenverarbeitung</h5>
                <p v-if="!prefillData">Um deinem/n Kind(ern) die Geburtstagsüberraschung zusenden zu können, stelle bitte sicher, dass du
                    uns deine Einwilligung zur Datenverarbeitung gibst.</p>

                <div v-if="!prefillData" class="form-group mb-30">
                    <label class="standalone">Einwilligung zur Datenverarbeitung*:</label>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-validate="'required'" name="optin-1" id="optin-1" v-model="optin1">
                        <label class="form-check-label" for="optin-1">
                            Ich stimme in meinem Namen und im Namen meines Kindes (meiner Kinder) zu, dass McDonald's
                            Deutschland LLC, Zweigniederlassung München die oben angegebenen Daten verarbeitet, um mir
                            für mein Kind (meine Kinder) (im Alter zwischen 0 und 13 Jahren) einen Geburtstagsgutschein
                            elektronisch und per Post zuzusenden. Diese Zustimmung kann ich auch nachträglich jederzeit
                            gegenüber McDonald's Deutschland LLC, Zweigniederlassung München per E-Mail an
                            datenschutz@de.mcd.com widerrufen. Der Widerruf lässt die Rechtmäßigkeit der Verarbeitung
                            bis zum Widerruf unberührt.
                        </label>
                    </div>
                </div>

                <!--  ###################################
                  GWS CTA / Eyecatcher for PopUp
                #########################################
                -->
<!--                <a v-b-modal.gewinneModal class="text-center eyecatcher">-->
<!--                    <img src="/assets/images/Stoerer-350x350.png" width="175" height="175" class="mb-30 mr-60">-->
<!--                </a>-->


<!--                <h5 class="mb-0">Der Family-Newsletter</h5>-->
<!--                <br/>-->
<!--                <p>Erhaltet immer als Erste alle News rund um McDonald’s sowie viele spannende Familienthemen direkt in euer Postfach.</p>-->
                <!--  ###################################
                  GWS + Teilnahmebedingungen & Datenschutz
                #########################################
                -->
<!--                <p>-->
<!--                  Hier findest du die <a href="https://www.mcdonalds.com/content/dam/de/Datenschutz/Datenschutzinformationen-Chilis-16.11.20.pdf" title="Datenschutzinformationen" target="_blank">Datenschutzinformationen</a>.-->
<!--                </p>-->

<!--                <div class="form-group mb-30">-->
<!--                    <label class="standalone">Family News abonnieren:</label>-->
<!--                    <div class="form-check">-->
<!--                        <input class="form-check-input" type="checkbox" id="optin-2" v-model="optin2">-->
<!--                        <label class="form-check-label" for="optin-2">-->
<!--                            Ich stimme zu, dass McDonald's Deutschland LLC, Zweigniederlassung München mir Newsletter-->
<!--                            und allgemeine Informationen zu Family-Themen von McDonald’s per E-Mail zusendet. Diese-->
<!--                            Zustimmung kann ich auch nachträglich jederzeit gegenüber McDonald's Deutschland LLC,-->
<!--                            Zweigniederlassung München widerrufen. Der Widerruf lässt die Rechtmäßigkeit der-->
<!--                            Verarbeitung bis zum Widerruf unberührt.-->
<!--                        </label>-->
<!--                    </div>-->
<!--                </div>-->

                <h5 class="mb-0">Datenschutz</h5>
                <div class="form-group mb-30">
                    <label class="standalone">Einwilligung zu Teilnahmebedingungen und Datenschutz*:</label>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-validate="'required'" name="optin-3" id="optin-3" v-model="optin3">
                        <label class="form-check-label" for="optin-3">
                          Ich habe die McDonald’s <a href="https://www.mcdonalds.com/content/dam/sites/de/unreferenced/Datenschutz/Datenschutzinformationen_McDonalds_Junior_Club.pdf" target="_blank">Datenschutzerklärung</a> zur Kenntnis genommen.
                        </label>
                    </div>
                </div>

            </b-col>
        </b-row>

        <b-row class="justify-content-center">
            <b-col sm="4" class="text-center">
                <button class="btn mt-2 btn-primary"
                        type="button"
                        @click="sendCompleteRegistration"
                        :disabled="formAlreadySubmitted || !completed">Absenden
                </button>
            </b-col>
        </b-row>

    </form>
</div>
</template>
<script>
    import profileChangeFavouriteRestaurantComponent from '../components/profile-change-favourite-restaurant.vue';
    import profileDataAddChildComponent from '../components/profile-add-child.vue';
    import {apiCompleteRegistration, apiDigitalRegistration } from "../utils/api";
    import bcrypt from "bcryptjs";
    import gewinneModal from "../components/gewinne-modal.vue";
    import smsAuthModal from "../components/sms-auth-modal.vue";

    //import saltedMd5 from 'salted-md5'

    export default {
        name: 'registerFullView',
        components: {
            profileChangeFavouriteRestaurantComponent,
            profileDataAddChildComponent,
            gewinneModal,
            smsAuthModal
        },
        props: {
            prefillData: Object,
            default: {}
        },
        data() {
            return {
                initialRequestData: {},
                optInCode: '',
                message: '',
                emailFromRegistration: '',
                firstnameFromRegistration: '',
                lastnameFromRegistration: '',
                address: {
                    street: '',
                    housenumber: '',
                    postcode: '',
                    city: '',
                    country: null,
                },
                newPassword: '',
                favoriteRestaurant: '',
                isActive: false,
                birthYearOptions: this.getYears(),
                optin1: false,
                optin2: false,
                optin3: false,
                children: [
                    {
                        membershipNumber: null,
                        // salutation: "",
                        firstname: "",
                        lastname: "",
                        birthMonth: "",
                        birthYear: ""
                    }
                ],
              smscode:'',
              initialRequestLoaded: false,
              checkIfSmsIsConfirmableAfterInitialRequest: false,
              formAlreadySubmitted: false
            };
        },
        methods: {
          preventDoubleClickOnSubmit() {
            //adds 5 sec delay for the user to click the submit button again
            this.formAlreadySubmitted = true
            setTimeout(() => {
              this.formAlreadySubmitted = false
            }, 5000)
          },

            sendCompleteRegistration(e) {
              this.preventDoubleClickOnSubmit()

              console.log(this.formAlreadySubmitted)
                e.preventDefault();

                let salt = '$2a$10$Y9WDFNqH6NSSjS7e0RcjNe',
                    pwd = bcrypt.hashSync(this.newPassword, salt);

                apiCompleteRegistration(
                    {
                        "optInCode": this.optInCode,
                        "parentAddress": this.address,
                        "passwordhash": pwd,
                        "favoriteRestaurant": this.favoriteRestaurant,
                        "optin1": {
                            "optinAgreement": this.optin1,
                            "optinFormId": "Einwilligung zur Datenverarbeitung"
                        },
                        "optin2": {
                            "optinAgreement": this.optin2,
                            "optinFormId": "Family News abonnieren"
                        },
                        "optin3": {
                            "optinAgreement": this.optin3,
                            "optinFormId": "Teilnahmebedingungen & Datenschutz"
                        },
                        "children": this.children
                    }
                )
                    .then(response => {

                        let code = response.data.code;

                        if (code === 0) {
                            this.$toasted.success('Registrierung erfolgreich abgeschlossen.', {
                                duration: 3000,
                                position: 'bottom-right'
                            });
                            this.$router.push({path: '/login'});
                        } else if(code === 1) {
                            this.toast('Persönliche Daten des Elternteils ungültig. Bitte überprüfen Sie diese. ');
                        } else if(code === 2){
                                this.toast('Mitgliedsnummer mindestens eines Kindes fehlt');
                        } else if(code === 3){
                            this.toast('Mitgliedsnummer bei Neuregistrierung übermittelt');
                        } else if(code === 4){
                            this.toast('Zu diesem Opt-In-Code liegt keine Registrierung vor');
                        } else if(code === 5){
                            this.toast('Mitgliedsnummer unbekannt');
                        } else if(code === 6){
                            this.toast('Opt-In-Code fehlt. Bitte klicken Sie auf den Link in Ihrer Bestätigungs-E-Mail.');
                        } else if(code === 99){
                            this.toast('Pflichtfeld nicht ausgefüllt');
                        } else if(code === 100){
                            this.toast('Ungültige oder unzulässige E-Mail-Adresse');
                        } else if(code === 101){
                            this.toast('Die Registrierung ist nicht möglich. Bitte wenden Sie sich an den Gästeservice.');
                        } else if(code === 102){
                            this.toast('Unter diesem Namen ist bereits ein Kind registriert');
                        } else if(code === 103){
                            this.toast('Altersprüfung eines Kindes fehlgeschlagen (nur möglich für Kinder zwischen 0-13 Jahren)');
                        } else if(code === 104){
                            this.toast('Elternteilzuordnung mindestens eines Kindes bereits vorhanden');
                        } else if(code === 105){
                            this.toast('Das Restaurant wurde nicht erkannt');
                        } else if(code === 106){
                            this.toast('Du hast mindestens ein Kind doppelt angegeben. Bitte überprüfe deine Angaben');
                        } else {
                            this.toast('Etwas ist schief gelaufen, bitte versuche es erneut!');
                        }
                    })
                    .catch(e => {
                        this.$store.commit('error', e);
                    });
            },

            toast(text){
                this.$toasted.error(text, {
                    duration: 3000,
                    position: 'bottom-right'
                });
            },

            addChild() {
                this.children.push(
                    {
                        membershipNumber: null,
                        // salutation: "",
                        firstname: "",
                        lastname: "",
                        birthMonth: "",
                        birthYear: ""
                    }
                )
            },

            removeChild(i){
                this.children.splice(i, 1);
            },

            setFavRestaurant(val){

                console.log('SET FAV REST', val)

                this.favoriteRestaurant = val;
            },

            valid(name) {
                return this.fields[name] && this.fields[name].touched && !this.fields[name].valid
            },

            getYears: function (param) {
                let thisYear = new Date().getFullYear();
                let year = thisYear - 14;
                if (param) {
                    return year;
                }

                let options = [];
                options.push({value: null, text: 'Jahr'});
                while (year <= thisYear) {
                    options.push({value: year, text: year});
                    year++;
                }
                return options;
            },
            showPassword(x) {
                if (x.type === "password") {
                    x.type = "text";
                } else {
                    x.type = "password";
                }

            }
        },
        created() {
            if (this.prefillData) {
                this.optin1 = true;
                this.optin3 = true;
                this.optInCode = this.prefillData.optInCode;
                this.emailFromRegistration = this.prefillData.emailFromRegistration;
                this.firstnameFromRegistration = this.prefillData.firstnameFromRegistration;
                this.lastnameFromRegistration = this.prefillData.lastnameFromRegistration;
                this.favoriteRestaurant = this.prefillData.favoriteRestaurant;
                this.address.street = this.prefillData.address.street;
                this.address.housenumber = this.prefillData.address.housenumber;
                this.address.postcode = this.prefillData.address.postcode;
                this.address.city = this.prefillData.address.city;
                this.address.country = this.prefillData.address.country;
                this.children = this.$store.state.profileData.children;
            }

        },
        mounted () {
            if (this.$route.query.oic) {
                this.optInCode = this.$route.query.oic;
            }

            if (!this.prefillData) {
                apiDigitalRegistration({
                    "optInCode": this.optInCode
                }).then(response => {
                  this.initialRequestData = response.data
                  this.emailFromRegistration = this.initialRequestData.emailFromRegistration
                  if(response.data.code === 0) {
                    this.checkIfSmsIsConfirmableAfterInitialRequest = true;
                  }
                  this.initialRequestLoaded = true;
                });
            }
        },
        computed: {
            completed() {
                // return Object.keys(this.fields).every(key => this.fields[key].validated) && Object.keys(this.fields).every(key => this.fields[key].valid)
                return Object.keys(this.fields).every(key => this.fields[key].valid) && this.favoriteRestaurant;
            },
            eightChars: function () {
                return this.newPassword.length > 7;
            },
            largeChar: function () {
                return (/[A-Z]/.test(this.newPassword));
            },
            smallChar: function () {
                return (/[a-z]/.test(this.newPassword));
            },
            specialChar: function () {
                return (/[~`!#$%\^&*@+=\-\[\]\\';,/{}|\\":<>\?]/g.test(this.newPassword));
            },
            validPassword: function () {
                return this.eightChars && this.largeChar && this.smallChar && this.specialChar
            }
        }
    };
</script>
